export class UpperCaseFirstLetter {
  public static OnFilterApplied(input: string) {
    input = input.toLowerCase();
    const words = input.split(' ');

    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
    }

    return words.join(' ');
  }
}